const usuario = "sulahub_admin";
const senha = "s53lys]sid83yyyf5fafwf";

export function getAuthHeader() {
  return {
    'Authorization': 'Basic ' + btoa(`${usuario}:${senha}`)
  };
}
